import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

// MUI imports
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';

import '@fontsource/poppins';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';

// Create MUI theme with Poppins font
const theme = createTheme({
  typography: {
    fontFamily: 'Poppins, sans-serif',
    fontSize: 13,
    body1: {
      letterSpacing: '0px'
    },
    body2: {
      letterSpacing: '-0.5px'
    },
    button: {
      letterSpacing: '0px'
    },
    caption: {
      letterSpacing: '0px'
    },
    h1: {
      letterSpacing: '0px'
    },
    h2: {
      letterSpacing: '0px'
    },
    h3: {
      letterSpacing: '0px'
    },
    h4: {
      letterSpacing: '0px'
    },
    h5: {
      letterSpacing: '-0.6px'
    },
    h6: {
      letterSpacing: '0px'
    },
    overline: {
      letterSpacing: '0px'
    },
    subtitle1: {
      letterSpacing: '0px'
    },
    subtitle2: {
      letterSpacing: '0px'
    }
  },
});


ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
